module.exports = __webpack_public_path__ + "static/media/PromoCh_bkg.2ea3a2a5.jpg";